// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const e = {
  production: true, // Set to true before the production build and deployment
  serverUrl: '',
  rootUrl: '',
  loginUrl: '/login',
  assets: '../../../assets',
  wsEndpoint: '',
  wsReconnectInterval: 2000,
  refreshInterval: 60000,
  stage: 'jcpdev',
  apiServiceId: 'u4cxw0d5dk',
  accessKeyId: '',
  secretAccessKey: '',
  column_name: 'Parent Node',
  custom_field: 'subclass_id',
  prod_labels: ['Department', 'Subdepartment', 'Class', 'Subclass'],
  bourneUrl: '',
  region: 'us-east-1',
  cognito: {
    userPoolId: 'us-east-1_uPDs9gWAw',
    userPoolClientId: '3ivpjc3oojfa6ok5e6uo1qg7uf',
    oauthDomain: 'us-east-1upds9gwaw.auth.us-east-1.amazoncognito.com',
    redirectSignIn: [
      'http://localhost:4200/',
      'https://d1q7q6anyrzcfl.cloudfront.net/',
      'https://jcp-dev.sizeo.ai/'
    ],
    redirectSignOut: [
      'http://localhost:4200/logout/',
      'https://d1q7q6anyrzcfl.cloudfront.net/logout/',
      'https://jcp-dev.sizeo.ai/logout/'
    ]
  },
  appsync: {
    endpoint: 'https://4ebmoqgftvhurim7qtggfzlve4.appsync-api.us-east-1.amazonaws.com/graphql'
  }
}

export const environment = e

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
